import { View } from 'react-native';
import * as Colours from '../colours';

const Sep = ({height}) => (<View style={{height: height || 0, justifyContent: 'center'}}><View style={{height: 0, borderBottomWidth: 1, borderColor: Colours.light_grey, alignSelf:'stretch'}} /></View>)

export default Sep;